export const basTypes = [
    {
        items: [
            {
                id:   1,
                name: 'BacnetEthernet'
            },
            {
                id:   2,
                name: 'BacnetIP'
            },
            {
                id:   3,
                name: 'Niagara'
            }
        ],
        name:      'BAS Types',
        itemProps: {
            type: 'basType'
        }
    }
];
